const messages = {
  "dashboard": {
    "title": "Dashboard Groothandelaar",
    "extraTitle": "DASHBOARD GROOTHANDELAAR",
    "description": "Welkom op uw dashboard. Hier kunt u de cijfers en deelnemende bedrijven van uw klantenbestand bekijken.",
    "overview": {
      "title": "Overzicht van deelnemende klanten",
      "description": "Bedrijven die zich hebben geregistreerd bij BRIDGESTONE PLUS en die we via hun klantnummer aan uw bedrijven kunnen toewijzen.",
      "month": "Nieuw deze maand",
      "year": "Nieuw dit jaar",
      "all": "Totaal"
    },
    "credits": {
      "title": "Puntenkredieten {name}",
      "description": "Beloningspunten toegekend aan deelnemende bedrijven op basis van de door u geüploade verkoopcijfers. In dit overzicht worden de reguliere punten weergegeven zonder promoties.",
      "month": "Laatste maand",
      "year": "Huidig jaar",
      "prev_year": "Totaal",
      "allDealers": "Alle punten van handelaars"
    },
    "details": {
      "title": "Details van deelnemende klanten",
      "description": "Hieronder vindt u de bedrijven die zich hebben geregistreerd bij BRIDGESTONE <span class=\"text-danger\">PLUS</span> met een klantnummer {name} en aan u zijn toegewezen als verantwoordelijke. Gebruik gewoon de sorteerfuncties om de volgorde te wijzigen of gebruik het zoekveld."
    },
    "lastImport": "Laatste import van verkoopcijfers: <br/> <span class=\"text-danger\">{date}</span>",
    "loadMore": "Laad 20 extra handelaars",
    "tyres": {
      "title": "Banden",
      "description": "Banden gekocht door programma-deelnemers"
    }
  },
  "bonus": {
    "title": "Overzicht Bonus credits",
    "description": "Bonus in euro wordt toegekend aan deelnemende bedrijven op basis van ingediende verkoopcijfers.",
    "lastMonth": "Vorige maand",
    "currentMonth": "Huidige maand",
    "totalCurrentYear": "Totaal huidig jaar",
    "totalLastYear": "Totaal vorig jaar"
  },
  "points": {
    "title": "Overzicht Punten credits",
    "period": "Huidig kalenderjaar ({year})",
    "totalAwarded": "Totaal toegekende punten",
    "redeemed": "Ingewisselde punten",
    "totalBalance": "Totaal punten saldo",
    "redemptionRate": "Ingewisselde punten als percentage van de toegekende punten",
    "averageAwarded": "Gemiddeld toegekende punten per gekochte band",
    "standardAwarded": "Nettopunten uit berekende verkoopregels, inclusief retouren",
    "bsPlusInclBooster": "Punten uit verkoopregels met een positieve hoeveelheid",
    "perTire": "Ingewisselde punten per gekochte band"
  },
  "tires": {
    "title": "Overzicht aantal banden",
    "description": "Banden gekocht door de klanten",
    "prevMonth": "Vorige maand",
    "totalLastYear": "Totaal vorig jaar",
    "purchaseIndirect": "Aankoop via groothandel (indirect)",
    "purchaseDirect": "Aankoop via groothandel (direct)",
    "totalCurrentYear": "Totaal huidig jaar",
    "currentMonth": "Huidige maand"
  },
  "participating": {
    "title": "Overzicht van deelnemende klanten",
    "description": "Bedrijven die zich registreren bij BRIDGESTONE PLUS kunnen door ons worden toegewezen via het klantnummer.",
    "total": "Totaal",
    "newThisMonth": "Nieuw deze maand",
    "newThisYear": "Nieuw dit jaar",
    "createdInCurrentMonth": "Aangemaakt in huidige maand (door admin)",
    "loginsCurrentYear": "Aanmeldingen huidig jaar (na acceptatie van algemene voorwaarden)"
  },
  "brand": {
    "title": "Merk",
    "description": "Uw aankopen in detail",
    "centerTitle": "Per\nmerk"
  },
  "rim": {
    "title": "Velg",
    "centerTitle": "Per velg\nmaat"
  },
  "tireGoals": {
    "title": "Banden doelstellingen",
    "subtitle": "Verdien punten voor uw bandenaankopen.",
    "centerTitle": "Per\nbandenmaat",
    "tiresRemaining": "Resterende banden",
    "progressionTarget": "Voortgang doelstelling: ",
    "pointsEarnedPurchases": "punten verdiend\ndoor uw\naankopen",
    "pointsEarnedBoosters": "punten verdiend\ndoor\nboosters",
    "purchasesDetail": "Uw aankopen in detail",
    "cta": "Meer informatie over uw punten",
    "pointsTitle": "Uw punten",
    "pointsSubtitle": "Punten verdiend op uw Bridgestone aankopen",
    "achievementsTitle": "Uw prestaties",
    "achievementsSubtitle": "Uw jaarlijkse verbintenis:",
    "achievementsSubtitle2": "banden"
  },
  "score": {
    "title": "Score",
    "total": "Totaal",
    "credits": "Credits in",
    "deductions": "Aftrekkingen in",
    "unlockedPoints": "Ontgrendelde punten",
    "pendingPoints": "Punten nog niet beschikbaar"
  },
  "score_extended": {
    "title1": "Punten saldo",
    "title2": "Bonus in euro",
    "balance": "Punten saldo",
    "bonus_in_euro": "Bonus in euro",
    "date": "Datum",
    "added_points": "Punten toegevoegd in",
    "total_bands": "Totaal niveaus",
    "goal": "Doelstelling",
    "tyres_previous_year": "Banden verkocht vorig jaar",
    "tyres_current_year": "Banden verkocht dit jaar",
    "target_this_year": "Verkoopdoelstelling dit jaar",
    "bonus_this_year": "Bonus verdiend (€)",
    "loyal_minimum": "Minimum loyaliteitsniveau",
    "bonus_multiplier": "Bonus vermenigvuldigingspercentage"
  },
  "lastImport": {
    "label": "Laatste import van verkoopcijfers:",
    "on": "op"
  },
  "wholesalerTable": {
    "title": "Deelnemende klanten in detail",
    "description": "Hieronder vindt u de bedrijven die zich hebben geregistreerd bij BRIDGESTONE PLUS met het klantnummer van uw bedrijf. U kunt de filters gebruiken voor een andere sortering of de zoekfunctie gebruiken om klanten op te zoeken.",
    "downloadButton": "Downloads",
    "columns": {
      "customer_number": "Klantnr.",
      "address_company_name": "Bedrijf",
      "address_street": "Straat en huisnummer",
      "address_postal_code": "Postcode",
      "address_city": "Stad",
      "last_registration": "Laatste registratie",
      "network": "Netwerk",
      "profile_group": "Groep",
      "tires_amount": "Aantal banden",
      "point_balance": "Punten saldo",
      "bonus": "Bonus",
      "details": "Details"
    },
    "searchPlaceholder": "Zoek"
  },
  "dealerTable": {
    "columns": {
      "date": "Datum",
      "wholesaler_bs_plus": "Groothandelaar BS+",
      "customer_number": "Klantnummer",
      "article": "Artikel",
      "brand": "Merk",
      "product": "Product",
      "type": "Type",
      "inch": "Inch",
      "season": "Seizoen",
      "amount": "Aantal",
      "points": "Punten",
      "activity": "Activiteit",
      "total_points": "Totaal punten"
    },
    "title": "Handelaarstabel",
    "description": "Overzicht van handelaarsactiviteiten"
  },
  "business_units": {
    "title": "Bedrijfsonderdelen",
    "centerTitle": "Per\nonderdeel"
  },
  "season": {
    "title": "Seizoen",
    "centerTitle": "Per\ntijd van het jaar"
  }
};

export default {
  messages,
};
